import Manager from 'coreClasses/Manager';
import {getConfig} from 'coreUtils/utils';
import _cloneDeep from 'lodash/cloneDeep';
import {IContentSecurityPolicy, TContentSecurityPolicyDirective} from './ISecurity';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents ContentSecurityPolicyMgr
 */
class ContentSecurityPolicyMgr extends Manager {
	private contentSecurityPolicy: IContentSecurityPolicy;
	private metaContent: string|null;

	/**
	 * Represents ContentSecurityPolicyMgr
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @protected
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);
		this.contentSecurityPolicy = null;
		this.metaContent = null;
	}

	/**
	 * Returns the content security policy
	 * @returns {IContentSecurityPolicy} - content security policy
	 */
	getContentSecurityPolicy(): IContentSecurityPolicy {
		if (!this.contentSecurityPolicy) {
			const {contentSecurityPolicy: appContentSecurityPolicy} = getConfig() as {contentSecurityPolicy?: IContentSecurityPolicy};
			const contentSecurityPolicy: IContentSecurityPolicy = _cloneDeep(appContentSecurityPolicy);
			const dynamicContentSecurityPolicy: IContentSecurityPolicy
				= this.managerRepository.getConfigurationsMgr().get('sitePreferences.contentSecurityPolicy');

			if (/*isRemote() TODO: ask to Serhii if can be removed && */
				Object.keys(contentSecurityPolicy.remoteDirectives).length
			) {
				Object.keys(contentSecurityPolicy.remoteDirectives).forEach((directiveKey: string) => {
					contentSecurityPolicy.directives[directiveKey]
						= contentSecurityPolicy.remoteDirectives[directiveKey];
				});
			}

			if (dynamicContentSecurityPolicy?.directives
				&& Object.keys(dynamicContentSecurityPolicy.directives).length
			) {
				Object.keys(dynamicContentSecurityPolicy?.directives).forEach((directiveKey: string) => {
					const contentSecurityPolicyDirective: TContentSecurityPolicyDirective
						= contentSecurityPolicy?.directives[directiveKey];
					const dynamicContentSecurityPolicyDirective: TContentSecurityPolicyDirective
						= dynamicContentSecurityPolicy.directives[directiveKey];

					if (contentSecurityPolicyDirective && Array.isArray(contentSecurityPolicyDirective)) {
						contentSecurityPolicyDirective.push(...dynamicContentSecurityPolicyDirective);
					} else {
						contentSecurityPolicy.directives[directiveKey] = dynamicContentSecurityPolicyDirective;
					}
				});
			}

			this.contentSecurityPolicy = contentSecurityPolicy;
		}

		return this.contentSecurityPolicy;
	}

	/**
	 * Returns the content security policy meta content
	 * @returns {string} - meta content
	 */
	getMetaContent(): string {
		if (!this.metaContent) {
			const contentSecurityPolicyDirectives: string[] = [];
			const contentSecurityPolicy = this.getContentSecurityPolicy();

			Object.keys(contentSecurityPolicy?.directives).forEach((directiveKey)=> {
				const contentSecurityPolicyDirective: TContentSecurityPolicyDirective
					 = contentSecurityPolicy?.directives[directiveKey];
				const contentSecurityPolicyDirectiveValue: string|null = Array.isArray(contentSecurityPolicyDirective)
					? [...new Set(contentSecurityPolicyDirective)].join(' ')
					: contentSecurityPolicyDirective;

				contentSecurityPolicyDirectives.push(`${directiveKey} ${contentSecurityPolicyDirectiveValue};`);
			});

			this.metaContent = contentSecurityPolicyDirectives.join(' ');
		}

		return this.metaContent;
	}
}

export default ContentSecurityPolicyMgr;
